import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { UNITS } from "@/data/units";
import Logo from "@/components/Logo";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-emka border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 text-white/70 text-sm max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/80">
              <div className="flex items-start gap-2">
                <MapPin
                  size={16}
                  className="mt-0.5"
                  style={{ color: "var(--emka-gold)" }}
                />
                <span>{t.footer.address}</span>
              </div>
              <div className="flex items-start gap-2">
                <Mail
                  size={16}
                  className="mt-0.5"
                  style={{ color: "var(--emka-gold)" }}
                />
                <a
                  href="mailto:sales@emkagroup.eu"
                  className="hover:text-white"
                  data-testid="footer-email"
                >
                  sales@emkagroup.eu
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-4">
              {t.footer.quickLinks}
            </h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <Link to="/" className="hover:text-white">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-4">
              {t.footer.divisions}
            </h4>
            <ul className="space-y-2 text-sm text-white/70">
              {UNITS.map((u) => (
                <li key={u.slug}>
                  <Link
                    to={`/${u.slug}`}
                    className="hover:text-white flex items-center gap-2"
                  >
                    <span
                      className="inline-block h-1.5 w-1.5 rounded-full"
                      style={{ backgroundColor: u.accent }}
                    />
                    {t.catalogs[u.key]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>
            © {year} EMKA Group. {t.footer.rights}
          </span>
          <a
            href="https://brightmindsoftware.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit"
            className="hover:text-white transition-colors uppercase tracking-[0.16em] text-[10px] text-center"
          >
            Bu web sitesi{" "}
            <span style={{ color: "var(--emka-gold)" }}>
              BMS Yazılım ve Teknoloji
            </span>{" "}
            şirketi tarafından yapılmıştır
          </a>
          <span>EMKA Metal Bulgaria EOOD · Sofia, Bulgaria</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
